import {
  GET_COUPON,
  GET_COUPON_SUCCESS,
  GET_COUPON_ERROR,
} from './../../actionType'

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
}

const GetCoupon = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default GetCoupon
